<script>
export const pageName = '/membership-result';
export const pageRoute = '/membership/result';
export const title = 'UKRA membership'
export const requireMembership = false;
export const requireCompleteAccount = true;

import { getCurrentUserId } from '../../js/auth.js';
import { listenToProjection } from '@trullock/firebase-client';
import UserView from '../../../functions/domain/users/userView.js';
import StripeSessionView from '../../../functions/domain/users/stripeSessionView.js';

export default {
	data() {
		return {
			session: null
		}
	},

	methods: {
		async show(opts)
		{
			await listenToProjection([UserView, getCurrentUserId(), StripeSessionView, opts.session_id], session => this.session = session);
		}
	}
}

</script>
<template>
	<div class="container py-5">
		<div class="row">
			<div class="col col-12">
				<div v-if="session?.payment_status == 'unpaid'" class="card">
					<div class="card-body text-center">
						<span class="spinner-border spinner-border-sm text-primary my-5" role="status" aria-hidden="true"></span>
						<p class="mb-4">Processing payment...</p>
					</div>
				</div>
				<div v-else-if="session?.payment_status == 'paid'" class="card">
					<div class="card-header">
						<h4 class="card-header-title">Payment succeeded</h4>
					</div>
					<div class="card-body">
						<p>Your membership has been successfully purchased.</p>
						<a href="/" class="btn btn-primary">Go to dashboard <span class="fe fe-arrow-right-circle"></span></a>
					</div>
				</div>
				<div v-else class="card">
					<div class="card-body">
						<p>Something went wrong, please <a href="mailto:membership@ukra.org.uk">contact us</a> or try again.</p>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
